<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: '100vw', minHeight: '100vh'}" @hide="hideModal()">
        <q-modal-layout>
            <q-toolbar slot="header" :style="{display: display}">
                <q-btn flat round dense @click="hideModal()" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ library.title }}
                </q-toolbar-title>
            </q-toolbar>
            <div class="layout-padding">
                <div class="row gutter-md">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                        <q-card class="full-height">
                            <q-card-media>
                                <img :src="library.image_medium">
                            </q-card-media>

                            <q-card-main>
                                <span v-html="library.description" class="text-faded"></span>
                                <!-- <p class="text-faded">{{ library.description }}</p> -->
                                <p class="text-faded">{{ $t('category') }}: {{ getCategory(library.category) }}</p>
                            </q-card-main>

                            <q-card-separator />

                            <q-card-actions class="justify-center">
                                <q-btn flat :label="library.size" icon="far fa-hdd" />
                                <q-btn flat :label="library.hits" icon="fas fa-download" />
                                <q-btn flat :label="library.extension" :icon="$extensionIcon(library.extension)" />
                            </q-card-actions>

                            <q-card-separator />

                            <q-card-actions class="justify-center" v-if="library.allow_download">
                                <q-btn class="full-width q-my-sm" :label="$t('download')" icon="fas fa-download" color="primary" @click="downloadFile()" />
                            </q-card-actions>
                        </q-card>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
                        <q-card>
                            <q-card-main class="card-players">
                                <pdf-player @display='display=$event' :file_url="library.file_url_complete" :file_preview="library.file_preview" v-if="showPlayer(['pdf'])"  />

                                <office-player :file_url="library.file_url_complete" v-else-if="showPlayer(['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx'])" />

                                <image-player :file_url="library.file_url_complete" v-else-if="showPlayer(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'])" />

                                <video-player @display='display=$event' :file_url="library.file_url_complete" :id="library.id" v-else-if="showPlayer(['mp4'])" />

                                <div v-else class="q-mt-xl">
                                    <p><q-icon name="far fa-eye-slash" size="3rem" /></p>
                                    <p class="q-display-1 text-weight-medium">
                                        {{ $t('no_pre_visualization_avaliable') }}
                                    </p>
                                </div>
                            </q-card-main>
                        </q-card>
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Pdf from 'components/players/Pdf'
import Office from 'components/players/Office'
import Image from 'components/players/Image'
import Video from 'components/players/Video'

export default {
    props: ['library', 'show'],

    data() {
        return {
            display: 'flex'
        }
    },

    components: {
        'pdf-player': Pdf,
        'office-player': Office,
        'image-player': Image,
        'video-player': Video
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_categories: 'site_lists/library_file_categories'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('hideModal', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        downloadFile() {
            if (this.$q.platform.is.cordova) {
                cordova.InAppBrowser.open(this.library.file_url_download, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                this.hitDownload()
            }
            else {
                window.open(this.library.file_url_download, '_blank')
                this.hitDownload()
            }
        },

        hitDownload() {
            this.$axios.get(`/etraining_library_files/files/${this.library.id}/request_file_download/`, this.getHeader)
            .then(response => {
                this.$emit('changeHits', this.library.id)
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        hideModal() {
            this.$emit('hideModal', '')
        },

        showPlayer(type) {
            let obj = type.find((obj) => { return obj === this.library.extension })
            if (obj) return true
            else return false
        },

        getCategory(id) {
            let obj = this.all_categories.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        }
    },
}
</script>

<style lang="stylus" scoped>
.card-players
    height auto
    text-align center
</style>
